/**
 * @param {string} path
 * @returns {Boolean}
 */
import Vue from 'vue'; 
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
// html文字提取
export function extractParagraphText(html) {
  // 检查是否是纯文本（不包含HTML标签）
  const isPlainText = !html.includes('<') || !html.includes('>')
  if (isPlainText) {
    return html.trim()
  }
  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')
    
    // 移除图片和视频相关元素
    const mediaSelectors = [
      'img',                       // 图片标签
      'video',                     // 视频标签
      'audio',                     // 音频标签
      'iframe',                    // 嵌入式框架（可能包含视频）
      'figure',                    // 图片容器
      'picture',                   // 响应式图片容器
      '[class*="video"]',          // 类名包含video的元素
      '[class*="image"]',          // 类名包含image的元素
      '[class*="media"]'           // 类名包含media的元素
    ]
    
    mediaSelectors.forEach(selector => {
      const elements = doc.querySelectorAll(selector)
      elements.forEach(el => el.remove())
    })
    
    // 获取所有文本内容
    // 使用textContent获取所有文本，包括p标签内外
    let textContent = doc.body.textContent || ''
    
    // 清理多余的空格和空行
    textContent = textContent
      .replace(/\s+/g, ' ')        // 将多个空格替换为单个空格
      .replace(/\n\s*\n/g, '\n')   // 将多个空行替换为单个空行
      .trim()
    
    return textContent
  } catch (e) {
    // 解析失败时返回原文本
    return html.trim()
  }
}
// html放大图片
export function previewHtmlImage(event) {
  if (event.target.tagName === 'IMG') {
    const clickedImg = event.target;
    const container = event.currentTarget;
    const allImages = container.querySelectorAll('img');
    const imgList = Array.from(allImages).map(img => img.src);
    const currentIndex = Array.from(allImages).indexOf(clickedImg);
    Vue.prototype.$previewImage({
      multiple: true,
      imgList: imgList,
      nowImgIndex: currentIndex
    });
  }
}